import * as Joi from 'joi';
import { AcquirerTypes } from '../enums/acquirer-types.enum';
import { BusinessModeOfPayments } from '../enums/business-mode-payments';
import { BusinessTypes } from '../enums/business-type';
import { Gender } from '../enums/gender-enums';
import { Currency } from '../enums/retrieve-transaction.enums';
import { SettlementSchema } from './business-form.schema';
import { IncorporatorSchema } from './incorporator-signatory.schema';
import { SignatorySchema } from './signatoriy.schema';
const stringWithNumbersOnlyRegEx = /^\d+$/;

export const UpdateMerchantSchema = {};

const ModeOfPaymentSchema = Joi.number()
  .valid(...Object.values(BusinessModeOfPayments))
  .required()
  .messages({
    'any.only': 'Mode of payments is invalid.',
    'any.required': 'Mode of payments is required.',
    'number.base': 'Mode of payments is invalid.',
  });
const AcquirersSchema = Joi.number()
  .valid(...Object.values(AcquirerTypes))
  .required()
  .messages({
    'any.only': 'Acquirer is invalid.',
    'any.required': 'Acquirer is required.',
    'number.base': 'Acquirer is invalid.',
  });
export const UpdateOnboardingNonStarterSchema = Joi.object({
  businessTypeId: Joi.number()
    .valid(
      BusinessTypes.STARTER,
      BusinessTypes.SOLE_PROPRIETOR,
      BusinessTypes.PARTNERSHIP,
      BusinessTypes.CORPORATION
    )
    .required()
    .messages({
      'any.only': 'Business type is invalid.',
      'any.required': 'Business type is required.',
      'number.base': 'Business type is invalid.',
    }),

  merchantName: Joi.string().trim().min(1).max(64).required().messages({
    'any.required': 'Company name is required.',
    'string.base': 'Company name is invalid.',
    'string.empty': 'Company name is invalid.',
    'string.min': 'Company name can be at most 64 characters only.',
    'string.max': 'Company name can be at most 64 characters only.',
  }),
  merchantBusinessName: Joi.string()
    .trim()
    .min(1)
    .max(500)
    .required()
    .messages({
      'any.required': 'Business name is required.',
      'string.base': 'Business name is invalid.',
      'string.empty': 'Business name is invalid.',
      'string.min': 'Business name can be at most 500 characters only.',
      'string.max': 'Business name can be at most 500 characters only.',
    }),
  businessHandle: Joi.any(),
  merchantCompanyTin: Joi.string()
    .trim()
    .length(12)
    .pattern(stringWithNumbersOnlyRegEx)
    .required()
    .messages({
      'any.required': 'TIN is required.',
      'string.base': 'TIN is invalid.',
      'string.empty': 'TIN is invalid.',
      'string.length': 'TIN must be 12 digits.',
      'string.pattern.base': 'TIN must only contain digits',
    }),
  mainOfficeContactNumber: Joi.string()
    .trim()
    .min(1)
    .max(30)
    .regex(stringWithNumbersOnlyRegEx)
    .required()
    .messages({
      'any.required': 'Contact number is required.',
      'string.base': 'Contact number is invalid.',
      'string.empty': 'Contact number is invalid.',
      'string.pattern.base': 'Contact number is invalid.',
      'string.min': 'Contact number can be at most 30 characters only.',
      'string.max': 'Contact number can be at most 30 characters only.',
    }),
  mainOfficeBldgNameNo: Joi.string()
    .trim()
    .min(1)
    .max(200)
    .optional()
    .allow('')
    .messages({
      'string.base': 'Building name and number is invalid.',
      'string.empty': 'Building name and number is invalid.',
      'string.min':
        'Building name and number can be at most 200 characters only.',
      'string.max':
        'Building name and number can be at most 200 characters only.',
    }),
  mainOfficeStreetAddress: Joi.string()
    .trim()
    .min(1)
    .max(64)
    .required()
    .messages({
      'any.required': 'Street address is required.',
      'string.base': 'Street address is invalid.',
      'string.empty': 'Street address is invalid.',
      'string.min': 'Street address can be at most 64 characters only.',
      'string.max': 'Street address can be at most 64 characters only.',
    }),
  mainOfficeBarangay: Joi.string().trim().min(1).max(200).required().messages({
    'any.required': 'Barangay is required.',
    'string.base': 'Barangay is invalid.',
    'string.empty': 'Barangay is invalid.',
    'string.min': 'Barangay can be at most 200 characters only.',
    'string.max': 'Barangay can be at most 200 characters only.',
  }),
  mainOfficeCity: Joi.string().trim().min(1).max(100).required().messages({
    'any.required': 'City is required.',
    'string.base': 'City is invalid.',
    'string.empty': 'City is invalid.',
    'string.min': 'City can be at most 100 characters only.',
    'string.max': 'City can be at most 100 characters only.',
  }),
  mainOfficeProvince: Joi.string().trim().min(1).max(64).required().messages({
    'any.required': 'Province is required.',
    'string.base': 'Province is invalid.',
    'string.empty': 'Province is invalid.',
    'string.min': 'Province can be at most 64 characters only.',
    'string.max': 'Province can be at most 64 characters only.',
  }),
  mainOfficePostalCode: Joi.string()
    .trim()
    .min(4)
    .max(10)
    .regex(stringWithNumbersOnlyRegEx)
    .required()
    .messages({
      'any.required': 'Postal code is required.',
      'string.base': 'Postal code is invalid.',
      'string.empty': 'Postal code is invalid.',
      'string.min': 'Postal code must have 4 to 10 characters only.',
      'string.max': 'Postal code must have 4 to 10 characters only.',
      'string.pattern.base': 'Postal code is invalid.',
    }),

  registeredContactNumber: Joi.string()
    .trim()
    .max(30)
    .regex(stringWithNumbersOnlyRegEx)
    .optional()
    .messages({
      'string.base': 'Contact number is invalid.',
      'string.empty': 'Contact number is invalid.',
      'string.pattern.base': 'Contact number is invalid.',
      'string.max': 'Contact number can be at most 30 characters only.',
    }),
  registeredBldgNameNo: Joi.string()
    .trim()
    .max(200)
    .optional()
    .allow('')
    .messages({
      'string.base': 'Building name and number is invalid.',
      'string.empty': 'Building name and number is invalid.',
      'string.max':
        'Building name and number can be at most 200 characters only.',
    }),
  registeredStreetAddress: Joi.string()
    .trim()
    .allow('')
    .max(64)
    .optional()
    .messages({
      'string.base': 'Street address is invalid.',
      'string.empty': 'Street address is invalid.',
      'string.max': 'Street address can be at most 64 characters only.',
    }),
  registeredBarangay: Joi.string()
    .trim()
    .max(200)
    .optional()
    .allow('')
    .messages({
      'string.base': 'Barangay is invalid.',
      'string.empty': 'Barangay is invalid.',
      'string.max': 'Barangay can be at most 200 characters only.',
    }),
  registeredCity: Joi.string().trim().max(100).optional().allow('').messages({
    'string.base': 'City is invalid.',
    'string.empty': 'City is invalid.',
    'string.max': 'City can be at most 100 characters only.',
  }),
  registeredProvince: Joi.string()
    .trim()
    .max(64)
    .optional()
    .allow('')
    .messages({
      'string.base': 'Province is invalid.',
      'string.empty': 'Province is invalid.',
      'string.max': 'Province can be at most 64 characters only.',
    }),
  registeredPostalCode: Joi.string()
    .trim()
    .min(4)
    .max(10)
    .regex(stringWithNumbersOnlyRegEx)
    .optional()
    .allow('')
    .messages({
      'string.base': 'Postal code is invalid.',
      'string.empty': 'Postal code is invalid.',
      'string.min': 'Postal code must have 4 to 10 characters only.',
      'string.max': 'Postal code must have 4 to 10 characters only.',
      'string.pattern.base': 'Postal code is invalid.',
    }),

  isBrickAndMortarStore: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),
  industry: Joi.string().trim().min(1).max(200).required().messages({
    'any.required': 'Industry is required.',
    'string.base': 'Industry is invalid.',
    'string.empty': 'Industry is invalid.',
    'string.min': 'Industry can be at most 200 characters only.',
    'string.max': 'Industry can be at most 200 characters only.',
  }),
  serviceDescription: Joi.string().trim().required().messages({
    'any.required': 'Service description is required.',
    'string.base': 'Service description is invalid.',
    'string.empty': 'Service description is invalid.',
  }),
  modeOfPayment: Joi.array()
    .items(ModeOfPaymentSchema)
    .min(1)
    .required()
    .messages({
      'any.required': 'Mode of payments is required.',
      'array.base': 'Mode of payments must be an array.',
      'array.includesRequiredUnknowns': 'Mode of payments has invalid items.',
      'array.min': 'Please select at least 1 mode of payment',
    }),
  acquirers: Joi.array().items(AcquirersSchema).min(1).required().messages({
    'any.required': 'Acquirers is required.',
    'array.base': 'Acquirers must be an array.',
    'array.includesRequiredUnknowns': 'Acquirers has invalid items.',
    'array.min': 'Acquirers must have at least 1 item',
  }),
  currency: Joi.number()
    .valid(Currency.PHP, Currency.USD)
    .required()
    .allow(null)
    .messages({
      'any.only': 'Currency is invalid.',
      'any.required': 'Currency is required.',
      'number.base': 'Currency is invalid.',
    }),
  aubPartnerId: Joi.string().trim().optional().min(0).messages({
    'string.base': 'AUB partner ID is invalid.',
    'string.empty': 'AUB partner ID is invalid.',
  }),
  estimatedMonthlyGrossTransaction: Joi.string()
    .trim()
    .min(0)
    .optional()
    .messages({
      'string.base': 'Estimated Monthly Gross Transaction is invalid.',
      'string.empty': 'Estimated Monthly Gross Transaction is invalid.',
    }),
  businessWebsiteUrl: Joi.string().trim().min(0).optional().messages({
    'string.base': 'Business website is invalid.',
    'string.empty': 'Business website is invalid.',
  }),
  isBusinessWebsiteUnderDevelopment: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),
  facebookUrl: Joi.string().trim().min(0).optional().messages({
    'string.base': 'Facebook field is invalid.',
    'string.empty': 'Facebook field is invalid.',
  }),
  twitterUrl: Joi.string().trim().min(0).optional().messages({
    'string.base': 'Twitter field is invalid.',
    'string.empty': 'Twitter field is invalid.',
  }),
  instagramUrl: Joi.string().trim().min(0).optional().messages({
    'string.base': 'Instagram field is invalid.',
    'string.empty': 'Instagram field is invalid.',
  }),
  tiktokUrl: Joi.string().trim().min(0).optional().messages({
    'string.base': 'Tiktok field is invalid.',
    'string.empty': 'Tiktok field is invalid.',
  }),

  incorporators: Joi.array()
    .items(IncorporatorSchema)
    .min(0)
    .max(5)
    .required()
    .messages({
      'array.base': 'Incorporators must be an array.',
      'array.includesRequiredUnknowns': 'Incorporators has invalid items.',
      'array.min': 'Incorporators must have at least 1 to 5 items.',
      'array.max': 'Incorporators must have at least 1 to 5 items.',
    }),

  copyProToSignatory: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),
  signatories: Joi.array()
    .items(SignatorySchema)
    .min(0)
    .max(5)
    .required()
    .messages({
      'any.required': 'Signatories is required.',
      'array.base': 'Signatories must be an array.',
      'array.includesRequiredUnknowns': 'Signatories has invalid items.',
      'array.min': 'Signatories must have at least 1 to 5 items.',
      'array.max': 'Signatories must have at least 1 to 5 items.',
    }),

  copyProToRep: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),
  aFirstName: Joi.string().trim().min(1).max(100).required().messages({
    'any.required': 'First name is required.',
    'string.base': 'First name is invalid.',
    'string.empty': 'First name is invalid.',
    'string.min': 'First name can at most be 100 characters only.',
    'string.max': 'First name can at most be 100 characters only.',
  }),
  aMiddleName: Joi.string().trim().min(1).max(100).optional().messages({
    'string.base': 'Middle name is invalid.',
    'string.empty': 'Middle name is invalid.',
    'string.min': 'Middle name can at most be 100 characters only.',
    'string.max': 'Middle name can at most be 100 characters only.',
  }),
  aLastName: Joi.string().trim().min(1).max(100).required().messages({
    'any.required': 'Last name is required.',
    'string.base': 'Last name is invalid.',
    'string.empty': 'Last name is invalid.',
    'string.min': 'Last name can at most be 100 characters only.',
    'string.max': 'Last name can at most be 100 characters only.',
  }),
  aPosition: Joi.string().trim().min(1).max(100).required().messages({
    'any.required': 'Position is required.',
    'string.base': 'Position is invalid.',
    'string.empty': 'Position is invalid.',
    'string.min': 'Position can at most be 100 characters only.',
    'string.max': 'Position can at most be 100 characters only.',
  }),
  aEmailAddress: Joi.string().trim().min(1).max(100).required().messages({
    'any.required': 'Email address is required.',
    'string.base': 'Email address is invalid.',
    'string.empty': 'Email address is invalid.',
    'string.min': 'Email address can at most be 100 characters only.',
    'string.max': 'Email address can at most be 100 characters only.',
  }),
  aContactNumber: Joi.string()
    .trim()
    .min(1)
    .max(30)
    .regex(stringWithNumbersOnlyRegEx)
    .required()
    .messages({
      'any.required': 'Contact number is required.',
      'string.base': 'Contact number is invalid.',
      'string.empty': 'Contact number is invalid.',
      'string.pattern.base': 'Contact number is invalid.',
      'string.min': 'Contact number can at most be 30 characters only.',
      'string.max': 'Contact number can at most be 30 characters only.',
    }),
  aDateOfBirth: Joi.date().required().messages({
    'date.base': 'Date is invalid.',
  }),
  aTin: Joi.string()
    .trim()
    .length(9)
    .regex(stringWithNumbersOnlyRegEx)
    .optional()
    .allow('')
    .messages({
      'string.base': 'TIN is invalid.',
      'string.empty': 'TIN is invalid.',
      'string.length': 'TIN must be 9 digits.',
      'string.pattern.base': 'TIN must only contain digits.',
    }),
  aSss: Joi.string()
    .trim()
    .length(10)
    .regex(stringWithNumbersOnlyRegEx)
    .optional()
    .allow('')
    .messages({
      'string.base': 'SSS is invalid.',
      'string.empty': 'SSS is invalid.',
      'string.length': 'SSS must be 10 digits.',
      'string.pattern.base': 'SSS must only contain digits.',
    }),
  aMothersMaidenName: Joi.string().trim().optional().min(0).max(255).messages({
    'string.base': "Mother's maiden name is invalid.",
    'string.empty': "Mother's maiden name is invalid.",
    'string.max': "Mother's maiden name can be at most 255 characters only.",
  }),
  aGender: Joi.string()
    .optional()
    .valid(...Object.keys(Gender), null)
    .messages({
      'string.base': 'Gender is invalid.',
      'string.empty': 'Gender is invalid.',
    }),
  aAubNationalityCode: Joi.string()
    .regex(stringWithNumbersOnlyRegEx)
    .allow('')
    .trim()
    .max(10)
    .min(0)
    .optional()
    .messages({
      'string.base': 'AUB nationality code is invalid.',
      'string.empty': 'AUB nationality code is invalid.',
      'string.pattern.base': 'AUB nationality code is invalid.',
      'string.max': 'AUB nationality code must be at most 10 characters only.',
    }),
  aAubDeviceId: Joi.string().trim().optional().min(0).messages({
    'string.base': 'AUB device ID is invalid.',
    'string.empty': 'AUB device ID is invalid.',
  }),
  aAubIdCode: Joi.string().trim().optional().min(0).max(10).messages({
    'string.base': 'AUB ID code is invalid.',
    'string.empty': 'AUB ID code is invalid.',
    'string.max': 'AUB ID code must have at most 10 characters only.',
  }),
  aAubIdNumber: Joi.string().trim().optional().min(0).max(20).messages({
    'string.base': 'AUB ID number is invalid.',
    'string.empty': 'AUB ID number is invalid.',
    'string.max': 'AUB ID number can be at most 20 characters only.',
  }),
  aAubRegionCode: Joi.string().trim().optional().min(0).max(10).messages({
    'string.base': 'AUB region code is invalid.',
    'string.empty': 'AUB region code is invalid.',
    'string.max': 'AUB region code can be at most 10 characters only.',
  }),

  copyRepInfo: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),

  eFirstName: Joi.string().trim().max(100).optional().allow('').messages({
    'string.base': 'First name is invalid.',
    'string.empty': 'First name is invalid.',
    'string.min': 'First name can at most be 100 characters only.',
    'string.max': 'First name can at most be 100 characters only.',
  }),
  eMiddleName: Joi.string().trim().max(100).optional().allow('').messages({
    'string.base': 'Middle name is invalid.',
    'string.empty': 'Middle name is invalid.',
    'string.min': 'Middle name can at most be 100 characters only.',
    'string.max': 'Middle name can at most be 100 characters only.',
  }),
  eLastName: Joi.string().trim().max(100).optional().allow('').messages({
    'string.base': 'Last name is invalid.',
    'string.empty': 'Last name is invalid.',
    'string.min': 'Last name can at most be 100 characters only.',
    'string.max': 'Last name can at most be 100 characters only.',
  }),
  ePosition: Joi.string().trim().max(100).optional().allow('').messages({
    'string.base': 'Position is invalid.',
    'string.empty': 'Position is invalid.',
    'string.min': 'Position can at most be 100 characters only.',
    'string.max': 'Position can at most be 100 characters only.',
  }),
  eEmailAddress: Joi.string()
    .trim()

    .max(100)
    .optional()
    .allow('')
    .messages({
      'string.base': 'Email address is invalid.',
      'string.empty': 'Email address is invalid.',
      'string.min': 'Email address can at most be 100 characters only.',
      'string.max': 'Email address can at most be 100 characters only.',
    }),
  eContactNumber: Joi.string()
    .trim()

    .max(30)
    .regex(stringWithNumbersOnlyRegEx)
    .optional()
    .allow('')
    .messages({
      'string.base': 'Contact number is invalid.',
      'string.empty': 'Contact number is invalid.',
      'string.pattern.base': 'Contact number is invalid.',
      'string.min': 'Contact number can at most be 30 characters only.',
      'string.max': 'Contact number can at most be 30 characters only.',
    }),
  eDateOfBirth: Joi.date().optional().allow(null).messages({
    'date.base': 'Date is invalid.',
  }),
  eTin: Joi.string()
    .trim()
    .length(9)
    .regex(stringWithNumbersOnlyRegEx)
    .optional()
    .allow('')
    .messages({
      'string.base': 'TIN is invalid.',
      'string.empty': 'TIN is invalid.',
      'string.length': 'TIN must be 9 digits.',
      'string.pattern.base': 'TIN must only contain digits.',
    }),
  eSss: Joi.string()
    .trim()
    .length(10)
    .regex(stringWithNumbersOnlyRegEx)
    .optional()
    .allow('')
    .messages({
      'string.base': 'SSS is invalid.',
      'string.empty': 'SSS is invalid.',
      'string.length': 'SSS must be 10 digits.',
      'string.pattern.base': 'SSS must only contain digits.',
    }),
  settlements: Joi.array()
    .items(SettlementSchema)
    .min(1)
    .max(2)
    .required()
    .messages({
      'array.base': 'settlements must be an array.',
      'array.includesRequiredUnknowns': 'settlements has invalid items.',
      'array.min': 'settlements must have at least 1 to 2 items.',
      'array.max': 'settlements must have at least 1 to 2 items.',
    }),

  isWantPackworksWallet: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),
  isWantPayMayaBankWallet: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),
  isWantPayMayaBankAccount: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),

  isAMNameDisabled: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),
  isEMNameDisabled: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),

  idsOfValidSignatories: Joi.any(),
  idsOfValidSignatoriesBack: Joi.any(),
  idsOfValidSignatoriesSignature: Joi.any(),

  barangayBusinessPermit: Joi.any(),
  barangayBusinessPermitBack: Joi.any(),
  barangayBusinessPermitSignature: Joi.any(),

  storePhoto: Joi.any(),

  mayorsOrBusinessPermit: Joi.any(),
  mayorsOrBusinessPermitBack: Joi.any(),
  mayorsOrBusinessPermitSignature: Joi.any(),

  birCert2303: Joi.any(),
  birCert2303Back: Joi.any(),
  birCert2303Signature: Joi.any(),

  secCert: Joi.any(),
  secCertBack: Joi.any(),
  secCertSignature: Joi.any(),

  aoiAndByLaws: Joi.any(),
  aoiAndByLawsBack: Joi.any(),
  aoiAndByLawsSignature: Joi.any(),

  gis: Joi.any(),
  gisBack: Joi.any(),
  gisSignature: Joi.any(),

  secretarysCert: Joi.any(),
  secretarysCertBack: Joi.any(),
  secretarysCertSignature: Joi.any(),

  agreeTermsPrivacy: Joi.any(),
});

export const UpdateOnboardingStarterSchema = Joi.object({
  businessTypeId: Joi.number()
    .valid(
      BusinessTypes.STARTER,
      BusinessTypes.SOLE_PROPRIETOR,
      BusinessTypes.PARTNERSHIP,
      BusinessTypes.CORPORATION
    )
    .required()
    .messages({
      'any.only': 'Business type is invalid.',
      'any.required': 'Business type is required.',
      'number.base': 'Business type is invalid.',
    }),
  merchantName: Joi.string().trim().min(1).max(64).required().messages({
    'any.required': 'Company name is required.',
    'string.base': 'Company name is invalid.',
    'string.empty': 'Company name is invalid.',
    'string.min': 'Company name can be at most 64 characters only.',
    'string.max': 'Company name can be at most 64 characters only.',
  }),
  merchantBusinessName: Joi.any(),
  businessHandle: Joi.any(),
  merchantCompanyTin: Joi.string()
    .trim()
    .length(9)
    .regex(stringWithNumbersOnlyRegEx)
    .required()
    .messages({
      'any.required': 'TIN is required.',
      'string.base': 'TIN is invalid.',
      'string.empty': 'TIN is invalid.',
      'string.length': 'TIN must be 9 digits.',
      'string.pattern.base': 'TIN must only contain digits.',
    }),
  mainOfficeContactNumber: Joi.string()
    .trim()
    .min(1)
    .max(30)
    .regex(stringWithNumbersOnlyRegEx)
    .required()
    .messages({
      'any.required': 'Contact number is required.',
      'string.base': 'Contact number is invalid.',
      'string.empty': 'Contact number is invalid.',
      'string.pattern.base': 'Contact number is invalid.',
      'string.min': 'Contact number can be at most 30 characters only.',
      'string.max': 'Contact number can be at most 30 characters only.',
    }),
  mainOfficeBldgNameNo: Joi.string()
    .trim()
    .min(1)
    .max(200)
    .optional()
    .allow('')
    .messages({
      'string.base': 'Building name and number is invalid.',
      'string.empty': 'Building name and number is invalid.',
      'string.min':
        'Building name and number can be at most 200 characters only.',
      'string.max':
        'Building name and number can be at most 200 characters only.',
    }),
  mainOfficeStreetAddress: Joi.string()
    .trim()
    .min(1)
    .max(64)
    .required()
    .messages({
      'any.required': 'Street address is required.',
      'string.base': 'Street address is invalid.',
      'string.empty': 'Street address is invalid.',
      'string.min': 'Street address can be at most 64 characters only.',
      'string.max': 'Street address can be at most 64 characters only.',
    }),
  mainOfficeBarangay: Joi.string().trim().min(1).max(200).required().messages({
    'any.required': 'Barangay is required.',
    'string.base': 'Barangay is invalid.',
    'string.empty': 'Barangay is invalid.',
    'string.min': 'Barangay can be at most 200 characters only.',
    'string.max': 'Barangay can be at most 200 characters only.',
  }),
  mainOfficeCity: Joi.string().trim().min(1).max(100).required().messages({
    'any.required': 'City is required.',
    'string.base': 'City is invalid.',
    'string.empty': 'City is invalid.',
    'string.min': 'City can be at most 100 characters only.',
    'string.max': 'City can be at most 100 characters only.',
  }),
  mainOfficeProvince: Joi.string().trim().min(1).max(64).required().messages({
    'any.required': 'Province is required.',
    'string.base': 'Province is invalid.',
    'string.empty': 'Province is invalid.',
    'string.min': 'Province can be at most 64 characters only.',
    'string.max': 'Province can be at most 64 characters only.',
  }),
  mainOfficePostalCode: Joi.string()
    .trim()
    .min(4)
    .max(10)
    .regex(stringWithNumbersOnlyRegEx)
    .required()
    .messages({
      'any.required': 'Postal code is required.',
      'string.base': 'Postal code is invalid.',
      'string.empty': 'Postal code is invalid.',
      'string.min': 'Postal code must have 4 to 10 characters only.',
      'string.max': 'Postal code must have 4 to 10 characters only.',
      'string.pattern.base': 'Postal code is invalid.',
    }),
  isBrickAndMortarStore: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),
  industry: Joi.string().trim().min(1).max(200).required().messages({
    'any.required': 'Industry is required.',
    'string.base': 'Industry is invalid.',
    'string.empty': 'Industry is invalid.',
    'string.min': 'Industry can be at most 200 characters only.',
    'string.max': 'Industry can be at most 200 characters only.',
  }),
  serviceDescription: Joi.string().trim().required().messages({
    'any.required': 'Service description is required.',
    'string.base': 'Service description is invalid.',
    'string.empty': 'Service description is invalid.',
  }),
  modeOfPayment: Joi.array()
    .items(ModeOfPaymentSchema)
    .min(1)
    .required()
    .messages({
      'any.required': 'Mode of payments is required.',
      'array.base': 'Mode of payments must be an array.',
      'array.includesRequiredUnknowns': 'Mode of payments has invalid items.',
      'array.min': 'Please select at least 1 mode of payment',
    }),
  acquirers: Joi.array().items(AcquirersSchema).min(1).required().messages({
    'any.required': 'Acquirers is required.',
    'array.base': 'Acquirers must be an array.',
    'array.includesRequiredUnknowns': 'Acquirers has invalid items.',
    'array.min': 'Acquirers must have at least 1 item',
  }),
  currency: Joi.number()
    .valid(Currency.PHP, Currency.USD)
    .required()
    .allow(null)
    .messages({
      'any.only': 'Currency is invalid.',
      'any.required': 'Currency is required.',
      'number.base': 'Currency is invalid.',
    }),
  aubPartnerId: Joi.string().trim().optional().min(0).messages({
    'string.base': 'AUB partner ID is invalid.',
    'string.empty': 'AUB partner ID is invalid.',
  }),
  estimatedMonthlyGrossTransaction: Joi.string()
    .trim()
    .min(0)
    .optional()
    .messages({
      'string.base': 'Estimated Monthly Gross Transaction is invalid.',
      'string.empty': 'Estimated Monthly Gross Transaction is invalid.',
    }),
  businessWebsiteUrl: Joi.string().trim().min(0).optional().messages({
    'string.base': 'Business website is invalid.',
    'string.empty': 'Business website is invalid.',
  }),
  isBusinessWebsiteUnderDevelopment: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),
  facebookUrl: Joi.string().trim().min(0).optional().messages({
    'string.base': 'Facebook field is invalid.',
    'string.empty': 'Facebook field is invalid.',
  }),
  twitterUrl: Joi.string().trim().min(0).optional().messages({
    'string.base': 'Twitter field is invalid.',
    'string.empty': 'Twitter field is invalid.',
  }),
  instagramUrl: Joi.string().trim().min(0).optional().messages({
    'string.base': 'Instagram field is invalid.',
    'string.empty': 'Instagram field is invalid.',
  }),
  tiktokUrl: Joi.string().trim().min(0).optional().messages({
    'string.base': 'Tiktok field is invalid.',
    'string.empty': 'Tiktok field is invalid.',
  }),

  registeredContactNumber: Joi.any(),
  registeredBldgNameNo: Joi.any(),
  registeredStreetAddress: Joi.any(),
  registeredBarangay: Joi.any(),
  registeredCity: Joi.any(),
  registeredProvince: Joi.any(),
  registeredPostalCode: Joi.any(),

  incorporators: Joi.any(),

  copyProToSignatory: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),
  signatories: Joi.array()
    .items(SignatorySchema)
    .min(0)
    .max(5)
    .optional()
    .messages({
      'any.required': 'Signatories is required.',
      'array.base': 'Signatories must be an array.',
      'array.includesRequiredUnknowns': 'Signatories has invalid items.',
      'array.min': 'Signatories must have at least 1 to 5 items.',
      'array.max': 'Signatories must have at least 1 to 5 items.',
    }),

  copyProToRep: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),
  aFirstName: Joi.string().trim().min(1).max(100).required().messages({
    'any.required': 'First name is required.',
    'string.base': 'First name is invalid.',
    'string.empty': 'First name is invalid.',
    'string.min': 'First name can at most be 100 characters only.',
    'string.max': 'First name can at most be 100 characters only.',
  }),
  aMiddleName: Joi.string().trim().min(1).max(100).optional().messages({
    'string.base': 'Middle name is invalid.',
    'string.empty': 'Middle name is invalid.',
    'string.min': 'Middle name can at most be 100 characters only.',
    'string.max': 'Middle name can at most be 100 characters only.',
  }),
  aLastName: Joi.string().trim().min(1).max(100).required().messages({
    'any.required': 'Last name is required.',
    'string.base': 'Last name is invalid.',
    'string.empty': 'Last name is invalid.',
    'string.min': 'Last name can at most be 100 characters only.',
    'string.max': 'Last name can at most be 100 characters only.',
  }),
  aPosition: Joi.string().trim().min(1).max(100).required().messages({
    'any.required': 'Position is required.',
    'string.base': 'Position is invalid.',
    'string.empty': 'Position is invalid.',
    'string.min': 'Position can at most be 100 characters only.',
    'string.max': 'Position can at most be 100 characters only.',
  }),
  aEmailAddress: Joi.string().trim().min(1).max(100).required().messages({
    'any.required': 'Email address is required.',
    'string.base': 'Email address is invalid.',
    'string.empty': 'Email address is invalid.',
    'string.min': 'Email address can at most be 100 characters only.',
    'string.max': 'Email address can at most be 100 characters only.',
  }),
  aMothersMaidenName: Joi.string().trim().optional().min(0).max(255).messages({
    'string.base': "Mother's maiden name is invalid.",
    'string.empty': "Mother's maiden name is invalid.",
    'string.max': "Mother's maiden name can be at most 255 characters only.",
  }),
  aGender: Joi.string()
    .optional()
    .valid(...Object.keys(Gender), null)
    .messages({
      'string.base': 'Gender is invalid.',
      'string.empty': 'Gender is invalid.',
    }),
  aAubNationalityCode: Joi.string()
    .regex(stringWithNumbersOnlyRegEx)
    .trim()
    .allow('')
    .max(10)
    .min(0)
    .optional()
    .messages({
      'string.base': 'AUB nationality code is invalid.',
      'string.empty': 'AUB nationality code is invalid.',
      'string.pattern.base': 'AUB nationality code is invalid.',
      'string.max': 'AUB nationality code must be at most 10 characters only.',
    }),
  aAubDeviceId: Joi.string().trim().optional().min(0).messages({
    'string.base': 'AUB device ID is invalid.',
    'string.empty': 'AUB device ID is invalid.',
  }),
  aAubIdCode: Joi.string().trim().optional().min(0).max(10).messages({
    'string.base': 'AUB ID code is invalid.',
    'string.empty': 'AUB ID code is invalid.',
    'string.max': 'AUB ID code must have at most 10 characters only.',
  }),
  aAubIdNumber: Joi.string().trim().optional().min(0).max(20).messages({
    'string.base': 'AUB ID number is invalid.',
    'string.empty': 'AUB ID number is invalid.',
    'string.max': 'AUB ID number can be at most 20 characters only.',
  }),
  aAubRegionCode: Joi.string().trim().optional().min(0).max(10).messages({
    'string.base': 'AUB region code is invalid.',
    'string.empty': 'AUB region code is invalid.',
    'string.max': 'AUB region code can be at most 10 characters only.',
  }),
  aContactNumber: Joi.string()
    .trim()
    .min(1)
    .max(30)
    .regex(stringWithNumbersOnlyRegEx)
    .required()
    .messages({
      'any.required': 'Contact number is required.',
      'string.base': 'Contact number is invalid.',
      'string.empty': 'Contact number is invalid.',
      'string.pattern.base': 'Contact number is invalid.',
      'string.min': 'Contact number can at most be 30 characters only.',
      'string.max': 'Contact number can at most be 30 characters only.',
    }),
  aDateOfBirth: Joi.date().required().messages({
    'date.base': 'Date is invalid.',
  }),
  aTin: Joi.string()
    .trim()
    .length(9)
    .allow('')
    .regex(stringWithNumbersOnlyRegEx)
    .optional()
    .messages({
      'string.base': 'TIN is invalid.',
      'string.empty': 'TIN is invalid.',
      'string.length': 'TIN must be 9 digits.',
      'string.pattern.base': 'TIN must only contain digits.',
    }),
  aSss: Joi.string()
    .trim()
    .length(10)
    .allow('')
    .regex(stringWithNumbersOnlyRegEx)
    .optional()
    .messages({
      'string.base': 'SSS is invalid.',
      'string.empty': 'SSS is invalid.',
      'string.length': 'SSS must be 10 digits.',
      'string.pattern.base': 'SSS must only contain digits.',
    }),

  copyRepInfo: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),

  eFirstName: Joi.string().trim().max(100).optional().allow('').messages({
    'string.base': 'First name is invalid.',
    'string.empty': 'First name is invalid.',
    'string.min': 'First name can at most be 100 characters only.',
    'string.max': 'First name can at most be 100 characters only.',
  }),
  eMiddleName: Joi.string().trim().max(100).optional().allow('').messages({
    'string.base': 'Middle name is invalid.',
    'string.empty': 'Middle name is invalid.',
    'string.min': 'Middle name can at most be 100 characters only.',
    'string.max': 'Middle name can at most be 100 characters only.',
  }),
  eLastName: Joi.string().trim().max(100).optional().allow('').messages({
    'string.base': 'Last name is invalid.',
    'string.empty': 'Last name is invalid.',
    'string.min': 'Last name can at most be 100 characters only.',
    'string.max': 'Last name can at most be 100 characters only.',
  }),
  ePosition: Joi.string().trim().max(100).optional().allow('').messages({
    'string.base': 'Position is invalid.',
    'string.empty': 'Position is invalid.',
    'string.min': 'Position can at most be 100 characters only.',
    'string.max': 'Position can at most be 100 characters only.',
  }),
  eEmailAddress: Joi.string()
    .trim()

    .max(100)
    .optional()
    .allow('')
    .messages({
      'string.base': 'Email address is invalid.',
      'string.empty': 'Email address is invalid.',
      'string.min': 'Email address can at most be 100 characters only.',
      'string.max': 'Email address can at most be 100 characters only.',
    }),
  eContactNumber: Joi.string()
    .trim()

    .max(30)
    .regex(stringWithNumbersOnlyRegEx)
    .optional()
    .allow('')
    .messages({
      'string.base': 'Contact number is invalid.',
      'string.empty': 'Contact number is invalid.',
      'string.pattern.base': 'Contact number is invalid.',
      'string.min': 'Contact number can at most be 30 characters only.',
      'string.max': 'Contact number can at most be 30 characters only.',
    }),
  eDateOfBirth: Joi.date().optional().allow(null).messages({
    'date.base': 'Date is invalid.',
  }),
  eTin: Joi.string()
    .trim()
    .length(9)
    .regex(stringWithNumbersOnlyRegEx)
    .optional()
    .allow('')
    .messages({
      'string.base': 'TIN is invalid.',
      'string.empty': 'TIN is invalid.',
      'string.length': 'TIN must be 9 digits.',
      'string.pattern.base': 'TIN must only contain digits.',
    }),
  eSss: Joi.string()
    .trim()
    .length(10)
    .regex(stringWithNumbersOnlyRegEx)
    .optional()
    .allow('')
    .messages({
      'string.base': 'SSS is invalid.',
      'string.empty': 'SSS is invalid.',
      'string.length': 'SSS must be 10 digits.',
      'string.pattern.base': 'SSS must only contain digits.',
    }),

  settlements: Joi.array()
    .items(SettlementSchema)
    .min(1)
    .max(2)
    .required()
    .messages({
      'array.base': 'settlements must be an array.',
      'array.includesRequiredUnknowns': 'settlements has invalid items.',
      'array.min': 'settlements must have at least 1 to 2 items.',
      'array.max': 'settlements must have at least 1 to 2 items.',
    }),

  isWantPackworksWallet: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),
  isWantPayMayaBankWallet: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),
  isWantPayMayaBankAccount: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),

  isAMNameDisabled: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),
  isEMNameDisabled: Joi.boolean().required().messages({
    'any.required': 'Field is required.',
    'boolean.base': 'Field is invalid.',
  }),

  idsOfValidSignatories: Joi.any(),
  idsOfValidSignatoriesBack: Joi.any(),
  idsOfValidSignatoriesSignature: Joi.any(),

  barangayBusinessPermit: Joi.any(),
  barangayBusinessPermitBack: Joi.any(),
  barangayBusinessPermitSignature: Joi.any(),

  storePhoto: Joi.any(),

  mayorsOrBusinessPermit: Joi.any(),
  mayorsOrBusinessPermitBack: Joi.any(),
  mayorsOrBusinessPermitSignature: Joi.any(),

  birCert2303: Joi.any(),
  birCert2303Back: Joi.any(),
  birCert2303Signature: Joi.any(),

  secCert: Joi.any(),
  secCertBack: Joi.any(),
  secCertSignature: Joi.any(),

  aoiAndByLaws: Joi.any(),
  aoiAndByLawsBack: Joi.any(),
  aoiAndByLawsSignature: Joi.any(),

  gis: Joi.any(),
  gisBack: Joi.any(),
  gisSignature: Joi.any(),

  secretarysCert: Joi.any(),
  secretarysCertBack: Joi.any(),
  secretarysCertSignature: Joi.any(),

  agreeTermsPrivacy: Joi.any(),
  // bldgNameNo: Joi.any(),
});
